exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbody {\n  background-color: #f3f3f3;\n}\n", ""]);

// exports
